var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.form.cards),function(card){return _c('div',{key:card.id,staticClass:"col-md-5"},[_c('QuotationAgreementCard',{attrs:{"card":card,"product":_vm.product}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }